import {
  convertCelsiusToFahrenheit,
  convertCelsiusToRømer,
  convertCelsiusToRéaumur,
  convertCelsiusToNewton,
  convertCelsiusToDelisle,
  convertCelsiusToRankine,
  convertCelsiusToKelvin
} from "./CelsiusConversion";
import {
  convertDelisleToCelsius,
  convertDelisleToRømer,
  convertDelisleToRéaumur,
  convertDelisleToNewton,
  convertDelisleToRankine,
  convertDelisleToKelvin,
  convertDelisleToFahrenheit
} from "./DelisleConversion";
import {
  convertFahrenheitToRømer,
  convertFahrenheitToRéaumur,
  convertFahrenheitToNewton,
  convertFahrenheitToDelisle,
  convertFahrenheitToRankine,
  convertFahrenheitToKelvin,
  convertFahrenheitToCelsius
} from "./FahrenheitConversion";
import {
  convertKelvinToRømer,
  convertKelvinToRéaumur,
  convertKelvinToNewton,
  convertKelvinToDelisle,
  convertKelvinToRankine,
  convertKelvinToFahrenheit,
  convertKelvinToCelsius
} from "./KelvinConversion";
import {
  convertNewtonToRømer,
  convertNewtonToRéaumur,
  convertNewtonToDelisle,
  convertNewtonToRankine,
  convertNewtonToKelvin,
  convertNewtonToFahrenheit,
  convertNewtonToCelsius
} from "./NewtonConversion";
import {
  convertRankineToRømer,
  convertRankineToRéaumur,
  convertRankineToNewton,
  convertRankineToDelisle,
  convertRankineToKelvin,
  convertRankineToFahrenheit,
  convertRankineToCelsius
} from "./RankineConversion";
import {
  convertRéaumurToRømer,
  convertRéaumurToNewton,
  convertRéaumurToDelisle,
  convertRéaumurToRankine,
  convertRéaumurToKelvin,
  convertRéaumurToFahrenheit,
  convertRéaumurToCelsius
} from "./ReamurConversion";
import {
  convertRømerToRéaumur,
  convertRømerToNewton,
  convertRømerToDelisle,
  convertRømerToRankine,
  convertRømerToKelvin,
  convertRømerToFahrenheit,
  convertRømerToCelsius
} from "./RomerConversion";

function getFinalFahrenheitConversion(val, conType) {
  let result = "";
  if (conType === "fatocel") {
    result = convertFahrenheitToCelsius(parseFloat(val));
  } else if (conType === "fatodel") {
    result = convertFahrenheitToDelisle(parseFloat(val));
  } else if (conType === "fatokel") {
    result = convertFahrenheitToKelvin(parseFloat(val));
  } else if (conType === "fatonew") {
    result = convertFahrenheitToNewton(parseFloat(val));
  } else if (conType === "fatoran") {
    result = convertFahrenheitToRankine(parseFloat(val));
  } else if (conType === "fatorea") {
    result = convertFahrenheitToRéaumur(parseFloat(val));
  } else if (conType === "fatorom") {
    result = convertFahrenheitToRømer(parseFloat(val));
  }
  return result;
}

function getFinalCelsiusConversion(val, conType) {
  let result = "";
  if (conType === "celtofah") {
    result = convertCelsiusToFahrenheit(parseFloat(val));
  } else if (conType === "celtodel") {
    result = convertCelsiusToDelisle(parseFloat(val));
  } else if (conType === "celtokel") {
    result = convertCelsiusToKelvin(parseFloat(val));
  } else if (conType === "celtonew") {
    result = convertCelsiusToNewton(parseFloat(val));
  } else if (conType === "celtoran") {
    result = convertCelsiusToRankine(parseFloat(val));
  } else if (conType === "celtorea") {
    result = convertCelsiusToRéaumur(parseFloat(val));
  } else if (conType === "celtorom") {
    result = convertCelsiusToRømer(parseFloat(val));
  }

  return result;
}

function getFinalDelisleConversion(val, conType) {
  let result = "";
  if (conType === "detocel") {
    result = convertDelisleToCelsius(parseFloat(val));
  } else if (conType === "detofah") {
    result = convertDelisleToFahrenheit(parseFloat(val));
  } else if (conType === "detokel") {
    result = convertDelisleToKelvin(parseFloat(val));
  } else if (conType === "detonew") {
    result = convertDelisleToNewton(parseFloat(val));
  } else if (conType === "detoran") {
    result = convertDelisleToRankine(parseFloat(val));
  } else if (conType === "detorea") {
    result = convertDelisleToRéaumur(parseFloat(val));
  } else if (conType === "detorom") {
    result = convertDelisleToRømer(parseFloat(val));
  }

  return result;
}

function getFinalKelvinConversion(val, conType) {
  let result = "";
  if (conType === "ketocel") {
    result = convertKelvinToCelsius(parseFloat(val));
  } else if (conType === "ketodel") {
    result = convertKelvinToDelisle(parseFloat(val));
  } else if (conType === "ketofah") {
    result = convertKelvinToFahrenheit(parseFloat(val));
  } else if (conType === "ketonew") {
    result = convertKelvinToNewton(parseFloat(val));
  } else if (conType === "ketoran") {
    result = convertKelvinToRankine(parseFloat(val));
  } else if (conType === "ketorea") {
    result = convertKelvinToRéaumur(parseFloat(val));
  } else if (conType === "ketorom") {
    result = convertKelvinToRømer(parseFloat(val));
  }

  return result;
}

function getFinalNewtonConversion(val, conType) {
  let result = "";
  if (conType === "netocel") {
    result = convertNewtonToCelsius(parseFloat(val));
  } else if (conType === "netodel") {
    result = convertNewtonToDelisle(parseFloat(val));
  } else if (conType === "netofah") {
    result = convertNewtonToFahrenheit(parseFloat(val));
  } else if (conType === "netokel") {
    result = convertNewtonToKelvin(parseFloat(val));
  } else if (conType === "netoran") {
    result = convertNewtonToRankine(parseFloat(val));
  } else if (conType === "netorea") {
    result = convertNewtonToRéaumur(parseFloat(val));
  } else if (conType === "netorom") {
    result = convertNewtonToRømer(parseFloat(val));
  }

  return result;
}

function getFinalRankineConversion(val, conType) {
  let result = "";
  if (conType === "ratocel") {
    result = convertRankineToCelsius(parseFloat(val));
  } else if (conType === "ratodel") {
    result = convertRankineToDelisle(parseFloat(val));
  } else if (conType === "ratofah") {
    result = convertRankineToFahrenheit(parseFloat(val));
  } else if (conType === "ratokel") {
    result = convertRankineToKelvin(parseFloat(val));
  } else if (conType === "ratonew") {
    result = convertRankineToNewton(parseFloat(val));
  } else if (conType === "ratorea") {
    result = convertRankineToRéaumur(parseFloat(val));
  } else if (conType === "ratorom") {
    result = convertRankineToRømer(parseFloat(val));
  }

  return result;
}

function getFinalReamurConversion(val, conType) {
  let result = "";
  if (conType === "retocel") {
    result = convertRéaumurToCelsius(parseFloat(val));
  } else if (conType === "retodel") {
    result = convertRéaumurToDelisle(parseFloat(val));
  } else if (conType === "retofah") {
    result = convertRéaumurToFahrenheit(parseFloat(val));
  } else if (conType === "retokel") {
    result = convertRéaumurToKelvin(parseFloat(val));
  } else if (conType === "retonew") {
    result = convertRéaumurToNewton(parseFloat(val));
  } else if (conType === "retoran") {
    result = convertRéaumurToRankine(parseFloat(val));
  } else if (conType === "retorom") {
    result = convertRéaumurToRømer(parseFloat(val));
  }

  return result;
}

function getFinalRomerConversion(val, conType) {
  let result = "";
  if (conType === "rotocel") {
    result = convertRømerToCelsius(parseFloat(val));
  } else if (conType === "rotodel") {
    result = convertRømerToDelisle(parseFloat(val));
  } else if (conType === "rotofah") {
    result = convertRømerToFahrenheit(parseFloat(val));
  } else if (conType === "rotokel") {
    result = convertRømerToKelvin(parseFloat(val));
  } else if (conType === "rotonew") {
    result = convertRømerToNewton(parseFloat(val));
  } else if (conType === "rotoran") {
    result = convertRømerToRankine(parseFloat(val));
  } else if (conType === "rotorea") {
    result = convertRømerToRéaumur(parseFloat(val));
  }

  return result;
}

export {
  getFinalCelsiusConversion,
  getFinalFahrenheitConversion,
  getFinalDelisleConversion,
  getFinalKelvinConversion,
  getFinalNewtonConversion,
  getFinalRankineConversion,
  getFinalReamurConversion,
  getFinalRomerConversion
};
